// extracted by mini-css-extract-plugin
export var image = "ticket-office-search-result-module--image--a9b13";
export var infos = "ticket-office-search-result-module--infos--b4142";
export var label = "ticket-office-search-result-module--label--b53bf";
export var name = "ticket-office-search-result-module--name--802be";
export var wrapper = "ticket-office-search-result-module--wrapper--2d10f";